export default __webpack_public_path__ + "static/media/Comstruct_logo.3b07a221.jpg";